<template>
  <div class="h-full w-full flex flex-col">
    <div class="h-full container mx-auto">
      <div class="px-4 sm:px-8 flex flex-col h-full w-full py-4 sm:py-8">
        <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
          <div class="flex items-center text-sm font-light">
            <router-link to="/dashboard" class="opacity-50 hover:opacity-100">Dashboard</router-link>
            <span class="mx-2">/</span>
            <router-link to="/students-management" class="opacity-50 hover:opacity-100">Students</router-link>
            <span class="mx-2">/</span>
            <span>Graduating Students</span>
          </div>
          <div class="font-bold">Graduating Students</div>
        </div>

        <!-- Graduating Students Dashboard Start -->
        <div class="flex flex-col mt-8">
          <div class="grid grid-col-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-8">
            <div class="bg-white rounded-2xl border shadow-lg px-8 py-6">
              <div class="flex justify-between items-center">
                <div class="flex-grow flex flex-col">
                  <p class="text-xl">Total</p>
                  <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                  <h1 v-else class="text-3xl font-bold mt-1">{{ totalCount }}</h1>
                </div>
              </div>
            </div>
            <div v-if="isShowChart('ATHS')" class="bg-white rounded-2xl border shadow-lg px-8 py-6">
              <div class="flex justify-between items-center">
                <div class="flex-grow flex flex-col">
                  <p class="text-xl">ATS</p>
                  <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                  <h1 v-else class="text-3xl font-bold mt-1">{{ atsCount }}</h1>
                </div>
                <div class="flex-shrink-0">
                  <img class="h-8" src="../../assets/images/dashboard/alumni/ATS.png" alt="ATS" />
                </div>
              </div>
            </div>
            <div v-if="isShowChart('ADPOLY')" class="bg-white rounded-2xl border shadow-lg px-8 py-6">
              <div class="flex justify-between items-center">
                <div class="flex-grow flex flex-col">
                  <p class="text-xl">ADPOLY</p>
                  <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                  <h1 v-else class="text-3xl font-bold mt-1">{{ adpolyCount }}</h1>
                </div>
                <div class="flex-shrink-0">
                  <img class="h-12" src="../../assets/images/dashboard/alumni/ADPOLY.png" alt="ADPOLY" />
                </div>
              </div>
            </div>
            <div v-if="isShowChart('FCHS')" class="bg-white rounded-2xl border shadow-lg px-8 py-6">
              <div class="flex justify-between items-center">
                <div class="flex-grow flex flex-col">
                  <p class="text-xl">FCHS</p>
                  <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                  <h1 v-else class="text-3xl font-bold mt-1">{{ fchsCount }}</h1>
                </div>
                <div class="flex-shrink-0">
                  <img class="h-14" src="../../assets/images/dashboard/alumni/FCHS.png" alt="FCHS" />
                </div>
              </div>
            </div>
            <div v-if="isShowChart('ADVETI')" class="bg-white rounded-2xl border shadow-lg px-8 py-6">
              <div class="flex justify-between items-center">
                <div class="flex-grow flex flex-col">
                  <p class="text-xl">ADVETI</p>
                  <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                  <h1 v-else class="text-3xl font-bold mt-1">{{ advetiCount }}</h1>
                </div>
                <div class="flex-shrink-0">
                  <img class="h-16" src="../../assets/images/dashboard/alumni/ADVETI.png" alt="ADVETI" />
                </div>
              </div>
            </div>
          </div>

          <div class="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-8 mt-8">
            <div class="bg-white rounded-2xl border shadow-lg px-8 py-6">
              <h1 class="text-lg font-bold">Graduating Students / Entity</h1>
              <div v-if="isDashboardLoading" class="wd-380 ht-242-7 flex items-center">
                <div class="">
                  <div class="ml-8 wd-216 ht-216 rounded-full bg-gray-200 animate-pulse"></div>
                </div>
              </div>
              <apexchart v-else type="pie" width="380" :options="chartOptions1" :series="series1"></apexchart>
            </div>
            <div class="bg-white rounded-2xl border shadow-lg px-8 py-6">
              <h1 class="text-lg font-bold">Registration Status</h1>
              <div v-if="isDashboardLoading" class="wd-380 ht-242-7 flex items-center">
                <div class="">
                  <div class="ml-8 wd-216 ht-216 rounded-full bg-gray-200 animate-pulse"></div>
                </div>
              </div>
              <apexchart v-else type="pie" width="433" :options="chartOptions7" :series="series7"></apexchart>
            </div>
          </div>
        </div>
        <!-- Graduating Students Dashboard End -->

        <div class="grid grid-cols-1 gap-8 mt-8" v-if="isEntityWiseRegistrationSummary">
          <div class="bg-white rounded-2xl border shadow-lg px-8 py-6">
            <h1 class="text-lg font-bold">Registation Summary</h1>
            <div v-if="isDashboardLoading" class="ht-350 bg-gray-200 animate-pulse"></div>
            <apexchart v-if="!isDashboardLoading && isEntityWiseRegistrationSummary" type="bar" height="350"
              :options="chartOptions8" :series="series8"></apexchart>
          </div>
        </div>

        <div class="mt-4 flex justify-end items-center">
          <div v-if="isExportExcel"
            class="w-44 flex items-center justify-center hover:bg-purple-50 bg-ternary border-ternary hover:border-ternary border px-4 py-2 rounded-lg hover:text-ternary text-white">
            <base-spinner-with-text class-list="w-4 h-4" text="" text-class-list="text-white"></base-spinner-with-text>
            <span class="text-xs">Exporting Excel</span>
          </div>
          <div v-else @click="generateReport"
            class="w-44 flex items-center justify-center hover:bg-purple-50 bg-ternary border-ternary hover:border-ternary border px-4 py-2 rounded-lg cursor-pointer hover:text-ternary text-white">
            <font-awesome-icon :icon="['fas', 'file-excel']" />
            <span class="text-xs ml-2">Export Excel</span>
          </div>
        </div>

        <section class="mt-4 h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
          <div class="font-bold mb-4">Graduating Students List</div>
          <div class="flex justify-end flex-wrap">
            <!-- <h1 class="text-base md:text-lg font-semibold text-ternary">Students List</h1> -->
            <div class="flex justify-start items-center flex-wrap w-full">
              <div class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                <div class="text-sm mr-2">Entity:</div>
                <select v-model="filterByEntity" class="outline-none text-sm flex-grow">
                  <option value="">All</option>
                  <option :value="item.entity" v-for="(item, index) in filteredEntities" :key="index">
                    {{ getEntityName(item.entity) }}
                  </option>
                </select>
              </div>

              <div class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                <div class="text-sm mr-2">Campus:</div>
                <select v-model="filterByCampus" class="outline-none text-sm flex-grow">
                  <option value="">All</option>
                  <option :value="c.campus_code" v-for="(c, index) in filteredCampuses" :key="index">
                    {{ c.campus_code }}
                  </option>
                </select>
              </div>

              <div class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                <div class="text-sm mr-2">Local or Non Local:</div>
                <select v-model="filterByLocalOrNonLocal" class="outline-none text-sm flex-grow">
                  <option value="">All</option>
                  <option value="Local">Local</option>
                  <option value="Non Local">Non Local</option>
                </select>
              </div>

              <div class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                <div class="text-sm mr-2">Registration Status:</div>
                <select v-model="filterByRegistration" class="outline-none text-sm flex-grow">
                  <option value="">All</option>
                  <option value="yes">Registered</option>
                  <option value="pending">Pending</option>
                  <option value="no">Not Registered</option>
                </select>
              </div>
              <div class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                <div class="text-sm mr-2">{{ getSpecializationTitle }}:</div>
                <select v-model="filterBySpecialization" class="outline-none text-sm flex-grow">
                  <option value="">All</option>
                  <option :value="item" v-for="(item, index) in specializationsList" :key="index">
                    {{ item }}
                  </option>
                </select>
              </div>
              <div class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                <div class="text-sm mr-2">GPA:</div>
                <select v-model="filterByGpa" class="outline-none text-sm flex-grow">
                  <option value="">All</option>
                  <option value="1">2.0 – 2.4</option>
                  <option value="2">2.5 – 2.9</option>
                  <option value="3">3+</option>
                </select>
              </div>
              <div class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                <div class="text-sm mr-2">Nationality:</div>
                <select v-model="filterByNationality" class="outline-none text-sm flex-grow">
                  <option value="">All</option>
                  <option :value="item" v-for="(item, index) in nationalities" :key="index">{{ item }}</option>
                </select>
              </div>
              <div class="w-full sm:w-auto mb-4">
                <search @on-search="onSearch" class-list="px-4 h-8"></search>
              </div>
            </div>
          </div>

          <div class="flex justify-start">
            <div @click.stop="clearAllFilter()"
              class="px-3 py-1 text-sm border border-red-500 bg-red-500 hover:bg-white text-white hover:text-red-500 rounded-lg cursor-pointer">
              Clear All Filter
            </div>
          </div>

          <div class="flex flex-col" v-if="$apollo.queries.students.loading">
            <div class="flex flex-col overflow-x-auto">
              <div class="inline-block min-w-full py-2">
                <div class="overflow-x-auto">
                  <div class="min-w-full text-left text-sm font-light">
                    <div class="border-b font-medium dark:border-neutral-500">
                      <div class="flex">
                        <div class="px-6 py-2 text-gray-400 w-12 lg:w-16">#</div>
                        <div class="flex-grow px-6 py-2 text-gray-400">
                          <div class="w-32 md:w-auto">Name</div>
                        </div>
                        <div class="px-6 py-2 text-gray-400">
                          <div class="w-24 lg:w-40">Entity</div>
                        </div>
                        <div class="px-6 py-2 text-gray-400">
                          <div class="w-24 lg:w-40">Student ID</div>
                        </div>
                        <div class="px-6 py-2 text-gray-400">
                          <div class="w-24 lg:w-40">{{ getSpecializationTitle }}</div>
                        </div>
                        <div v-if="!isATS" class="px-6 py-2 text-gray-400">
                          <div class="w-24 lg:w-40">
                            Earned Credits / Requested Credit
                          </div>
                        </div>
                        <div v-if="isATS" class="px-6 py-2 text-gray-400">
                          <div class="w-24 lg:w-40">Percentage</div>
                        </div>
                        <div v-else class="px-6 py-2 text-gray-400">
                          <div class="w-24 lg:w-40">GPA</div>
                        </div>
                        <div class="px-6 py-2 text-gray-400">
                          <div class="w-24 lg:w-40">Is Registered</div>
                        </div>
                        <div class="px-6 py-2 text-gray-400 w-24 lg:w-40">Actions</div>
                      </div>
                    </div>
                    <div>
                      <student-tile-shimmer v-for="(sts, index) in first" :key="index"></student-tile-shimmer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="noItems" class="h-full flex justify-center items-center">
            <h1 class="text-center text-xl font-medium">No graduating students found!</h1>
          </div>
          <div v-else class="flex flex-col">
            <div class="flex flex-col overflow-x-auto">
              <div class="inline-block min-w-full py-2">
                <div class="overflow-x-auto">
                  <table class="min-w-full text-left text-sm font-light">
                    <thead class="border-b font-medium dark:border-neutral-500">
                      <tr>
                        <th scope="col" class="px-6 py-2 text-gray-400 w-8">#</th>
                        <th scope="col" class="px-6 py-2 text-gray-400">Name</th>
                        <th scope="col" class="px-6 py-2 text-gray-400">Entity</th>
                        <th scope="col" class="px-6 py-2 text-gray-400">Student ID</th>
                        <th scope="col" class="px-6 py-2 text-gray-400">
                          {{ getSpecializationTitle }}
                        </th>
                        <th v-if="!isATS" scope="col" class="px-6 py-2 text-gray-400">
                          Earned Credits / Requested Credit
                        </th>
                        <th v-if="isATS" scope="col" class="px-6 py-2 text-gray-400">
                          Percentage
                        </th>
                        <th v-else scope="col" class="px-6 py-2 text-gray-400">GPA</th>
                        <th scope="col" class="px-6 py-2 text-gray-400">Is Registered</th>
                        <th scope="col" class="px-6 py-2 text-gray-400">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(student, index) in filteredStudents" :key="index"
                        class="border-b border-dashed dark:border-neutral-500">
                        <td class="whitespace-nowrap px-6 py-2 font-medium">
                          {{ paginatorInfo.firstItem + index }}
                        </td>
                        <td class="whitespace-nowrap px-6 py-2">
                          <div class="flex items-center">
                            <div class="flex-shrink-0 mr-3">
                              <img @click.stop="openPreviewImgModalNew(student)"
                                class="h-12 w-12 rounded-lg object-cover cursor-pointer"
                                :src="studentProfileNew(student)" alt="" />
                            </div>
                            <div class="flex-grow flex flex-col">
                              <h1 class="text-sm font-semibold flex items-center">
                                <span @click.stop="viewStudentProfile(student.student_id)"
                                  class="text-heading hover:text-blue-600 hover:underline cursor-pointer">{{
                                    student.name_en }}</span>
                              </h1>
                              <p class="text-xs text-gray-400">{{ student.name_ar }}</p>
                            </div>
                          </div>
                        </td>
                        <td class="whitespace-nowrap px-6 py-2">
                          {{ getEntityName(student.entity) }}
                        </td>
                        <td class="whitespace-nowrap px-6 py-2">
                          {{ student.student_id }}
                        </td>
                        <td class="whitespace-nowrap px-6 py-2">
                          {{
                            getSpecialization(
                              student.entity,
                              student.study_program,
                              student.program_name,
                              student.program_code,
                              student.cluster_e,
                              student.specialization
                            )
                          }}
                        </td>
                        <td v-if="!isATS" class="whitespace-nowrap px-6 py-2">
                          {{
                            getCreditEarned(student.credits_earned, student.req_credit)
                          }}
                        </td>
                        <td class="whitespace-nowrap px-6 py-2">{{ student.gpa }}</td>
                        <td class="whitespace-nowrap px-6 py-2 capitalize">{{ student.reg_status }}</td>
                        <td class="px-6 py-2">
                          <div class="flex">
                            <div v-if="hasPermission('students-show')"
                              @click.stop="viewStudentProfile(student.student_id)"
                              class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                              <icon-eye
                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-eye>
                            </div>
                            <div v-if="hasPermission('students-show')" @click.stop="generatePdf(student.student_id)"
                              class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                              <icon-printer
                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-printer>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <pagination :paginatorInfo="paginatorInfo" :setPage="setPage"></pagination>
            </div>
          </div>

          <transition name="fade" mode="out-in">
            <base-modal v-if="previewImageModal" title="" height="50vh" @close="closePreviewImageModal">
              <img class="h-full w-full object-contain" :src="previewImg" />
            </base-modal>
          </transition>

          <transition name="fade" mode="out-in">
            <base-full-modal v-if="showStudentProfileFullModal" title="Student Profile" @close="closeFullModal">
              <student-profile :student-id="studentId"></student-profile>
            </base-full-modal>
          </transition>
        </section>
      </div>
    </div>
    <div class="h-full flex justify-center items-center" v-if="isExportExcel">
      <base-page-spinner type="spin" class-list="h-20"></base-page-spinner>
    </div>
  </div>
</template>
<script>
import IconEye from "../../components/icons/IconEye.vue";
import IconPrinter from "../../components/icons/IconPrinter.vue";
import gql from "graphql-tag";
import Pagination from "../../components/shared/pagination.vue";
import StudentTileShimmer from "../../components/students/StudentTileShimmer.vue";
import Search from "../../components/shared/search.vue";
import StudentProfile from "../student-profile/index.vue";
import xlsx from "xlsx/dist/xlsx.full.min.js";

export default {
  name: "graduating-students-index",
  components: {
    IconEye,
    IconPrinter,
    Pagination,
    StudentTileShimmer,
    Search,
    StudentProfile,
  },
  data() {
    return {
      students: [],
      first: 10,
      page: 1,
      studentId: null,
      searchText: "",
      filterByEntity: "",
      filterBySpecialization: "",
      filterByStatus: "AS",
      filterByCampus: "",
      filterByLocalOrNonLocal: "",
      filterByRegistration: "",
      previewImageModal: false,
      previewImg: "",
      isGenerateReport: false,
      entities: [],
      showStudentProfileFullModal: false,
      isDashboardLoading: false,
      totalCount: 0,
      atsCount: 0,
      adpolyCount: 0,
      fchsCount: 0,
      advetiCount: 0,
      registered: 0,
      pending: 0,
      notRegistered: 0,
      campus_wise_data: [],
      campus_wise_list: [],
      specializationsList: [],
      campusList: [],
      isEntityWiseRegistrationSummary: false,
      isExportExcel: false,
      isApiCallRecurisive: false,
      generatedReport: [],
      filterByGpa: "",
      filterByNationality: "",
      nationalities: [],
    };
  },
  created() {
    this.getSpecializations();
    this.getCampusList();
    this.getNationalities();
    this.getGraduatingStudentsDashboard();
  },
  watch: {
    searchText() {
      this.page = 1;
    },
    filterByEntity(val) {
      if (val != "") {
        this.isEntityWiseRegistrationSummary = true;
      } else {
        this.isEntityWiseRegistrationSummary = false;
      }

      this.clearAllFilter("filterByEntity");
      this.page = 1;
      this.getSpecializations();
      this.getGraduatingStudentsDashboard();
    },
    filterBySpecialization() {
      this.page = 1;
      this.getGraduatingStudentsDashboard();
    },
    filterByCampus() {
      this.page = 1;
      this.getGraduatingStudentsDashboard();
    },
    filterByLocalOrNonLocal() {
      this.page = 1;
      this.getGraduatingStudentsDashboard();
    },
    filterByRegistration() {
      this.page = 1;
      this.getGraduatingStudentsDashboard();
    },
    filterByGpa() {
      this.page = 1;
      this.getGraduatingStudentsDashboard();
    },
    filterByNationality() {
      this.page = 1;
      this.getGraduatingStudentsDashboard();
    },
  },
  computed: {
    getSpecializationTitle() {
      if (this.filterByEntity == "ATHS" || this.filterByEntity == "ATS") {
        return "Cluster";
      } else {
        return "Program";
      }
    },
    getCountryClass() {
      if (this.universityCountryResultsList.length > 0) {
        return "w-full lg:w-3/4";
      } else {
        return "w-full";
      }
    },
    getCountryListClass() {
      if (this.universityCountryResultsList.length > 0) {
        return "w-full lg:w-1/4";
      } else {
        return "w-full";
      }
    },
    noItems() {
      if (
        !this.$apollo.queries.students.loading &&
        this.filteredStudents.length <= 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    isATS() {
      if (this.filterByEntity == "ATHS" || this.filterByEntity == "ATS") {
        return true;
      } else {
        return false;
      }
    },
    filteredCampuses() {
      if (this.filterByEntity) {
        return this.campusList.filter(
          (campus) => campus.entity === this.filterByEntity
        );
      } else {
        return this.campusList;
      }
    },
    filteredStudents() {
      return this.students.data;
    },
    paginatorInfo() {
      return this.students.paginatorInfo;
    },
    role() {
      return this.$store.getters.role;
    },
    userEntities() {
      return this.$store.getters.entity;
    },
    filteredEntities() {
      return this.entities.data;
    },
    series1() {
      switch (this.filterByEntity) {
        case "ATHS":
          return [this.atsCount];
        case "ADPOLY":
          return [this.adpolyCount];
        case "FCHS":
          return [this.fchsCount];
        case "ADVETI":
          return [this.advetiCount];
        default:
          return [
            this.atsCount,
            this.adpolyCount,
            this.fchsCount,
            this.advetiCount,
          ];
      }
    },

    series8() {
      switch (this.filterByEntity) {
        case "ATHS":
          return [
            {
              name: "ATS Pending",
              data: this.campus_wise_data.map((item) => item.pending),
              //data: this.atsAcademicYearResults.map((result) => result.count),
            },
            {
              name: "ATS Registered",
              data: this.campus_wise_data.map((item) => item.registered),
              //data: this.atsAcademicYearResults.map((result) => result.count),
            },
            {
              name: "ATS Not Registered",
              data: this.campus_wise_data.map((item) => item.not_registered),
              //data: this.atsAcademicYearResults.map((result) => result.count),
            },
          ];
        case "ADPOLY":
          return [
            {
              name: "ADPOLY Pending",
              data: this.campus_wise_data.map((item) => item.pending),
              //data: this.atsAcademicYearResults.map((result) => result.count),
            },
            {
              name: "ADPOLY Registered",
              data: this.campus_wise_data.map((item) => item.registered),
              //data: this.atsAcademicYearResults.map((result) => result.count),
            },
            {
              name: "ADPOLY Not Registered",
              data: this.campus_wise_data.map((item) => item.not_registered),
              //data: this.atsAcademicYearResults.map((result) => result.count),
            },
          ];
        case "FCHS":
          return [
            {
              name: "FCHS Pending",
              data: this.campus_wise_data.map((item) => item.pending),
              //data: this.atsAcademicYearResults.map((result) => result.count),
            },
            {
              name: "FCHS Registered",
              data: this.campus_wise_data.map((item) => item.registered),
              //data: this.atsAcademicYearResults.map((result) => result.count),
            },
            {
              name: "FCHS Not Registered",
              data: this.campus_wise_data.map((item) => item.not_registered),
              //data: this.atsAcademicYearResults.map((result) => result.count),
            },
          ];
        case "ADVETI":
          return [
            {
              name: "ADVETI Pending",
              data: this.campus_wise_data.map((item) => item.pending),
              //data: this.atsAcademicYearResults.map((result) => result.count),
            },
            {
              name: "ADVETI Registered",
              data: this.campus_wise_data.map((item) => item.registered),
              //data: this.atsAcademicYearResults.map((result) => result.count),
            },
            {
              name: "ADVETI Not Registered",
              data: this.campus_wise_data.map((item) => item.not_registered),
              //data: this.atsAcademicYearResults.map((result) => result.count),
            },
          ];
        default:
          return [];
      }
    },

    chartOptions8() {
      return {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          //categories: this.academicYears,
          categories: this.campus_wise_list.map((item) => item.campus_code),
        },
        yaxis: {
          title: {
            text: "No of students",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
      };
    },

    chartOptions1() {
      const labels = this.getLabelBasedOnEntity();

      return {
        chart: {
          width: 380,
          type: "pie",
        },
        labels: labels,
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };
    },
    series7() {
      return [this.registered, this.pending, this.notRegistered];
    },
    chartOptions7() {
      const labelsWithCount = ["Registered", "Pending", "Not Registered"].map(
        (label, index) => {
          return `${label}: ${this.series7[index]}`;
        }
      );

      return {
        chart: {
          width: 433,
          type: "pie",
        },
        labels: labelsWithCount,
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
        colors: ["#008000", "#d97706", "#ff0000"],
      };
    },
  },
  apollo: {
    entities() {
      return {
        query: gql`
          query GetEntityList {
            entities {
              data {
                entity
              }
            }
          }
        `,
        fetchPolicy: "cache-and-network",
      };
    },
    students() {
      return {
        query: gql`
          query GetAllStudents(
            $first: Int!
            $page: Int!
            $search: String
            $entity: String
            $academic_year: String
            $student_status: String
            $campus: String
            $local_or_non_local: String
            $reg_status: String
            $is_employed: String
            $university_country: String
            $program_of_entry: String
            $university_name: String
            $specialization: String
            $program_degree_desc: String
            $filter_by_em_sat_subject: String
            $filter_by_em_sat_value: String
            $is_final_year_student: Boolean
            $gpa: String
            $nationality: String
          ) {
            students(
              first: $first
              page: $page
              search: $search
              entity: $entity
              academic_year: $academic_year
              student_status: $student_status
              campus: $campus
              local_or_non_local: $local_or_non_local
              reg_status: $reg_status
              is_employed: $is_employed
              university_country: $university_country
              program_of_entry: $program_of_entry
              university_name: $university_name
              specialization: $specialization
              program_degree_desc: $program_degree_desc
              filter_by_em_sat_subject: $filter_by_em_sat_subject
              filter_by_em_sat_value: $filter_by_em_sat_value
              is_final_year_student: $is_final_year_student
              gpa: $gpa
              nationality: $nationality
            ) {
              data {
                reg_status
                name_ar
                name_en
                student_id
                entity
                eid
                specialization
                program_code
                program_name
                study_program
                cluster_e
                credits_earned
                req_credit
                gpa
                profile_picture_url
              }
              paginatorInfo {
                count
                currentPage
                firstItem
                hasMorePages
                lastItem
                lastPage
                perPage
                total
              }
            }
          }
        `,
        variables() {
          return {
            first: this.first,
            page: this.page,
            search: this.searchText,
            entity: this.filterByEntity,
            academic_year: "",
            specialization: this.filterBySpecialization,
            student_status: this.filterByStatus,
            campus: this.filterByCampus,
            local_or_non_local: this.filterByLocalOrNonLocal,
            reg_status: this.filterByRegistration,
            is_final_year_student: true,
            gpa: this.filterByGpa,
            nationality: this.filterByNationality,
          };
        },
        fetchPolicy: "cache-and-network",
      };
    },
  },
  methods: {
    clearAllFilter(filterName = "") {
      if (!filterName) {
        this.filterByEntity = "";
      }
      this.filterByCampus = "";
      this.filterByLocalOrNonLocal = "";
      this.filterByRegistration = "";
      this.filterBySpecialization = "";
      this.filterByGpa = "";
      this.filterByNationality = "";
    },

    async generateReport() {
      var page = 1;
      var limit = 200;
      this.isExportExcel = true;
      this.isApiCallRecurisive = true;
      while (this.isApiCallRecurisive) {
        const responseData = await this.fetchForExporting(page, limit);
        if (responseData.data.length > 0) {
          this.generatedReport.push(
            ...responseData.data.map((obj) => {

              let regStatus;
              if (obj.reg_status == "yes") {
                regStatus = "Completed";
              } else if (obj.reg_status == 'pending') {
                regStatus = "Pending";
              } else {
                regStatus = "Not Registered";
              }

              let isEmiratesIdUploaded;
              if (obj.emirates_id_file) {
                isEmiratesIdUploaded = "Yes";
              } else {
                isEmiratesIdUploaded = "No";
              }

              let isPersonalPhotoUploaded;
              if (obj.user && obj.user.profile_picture_url != '/storage/alumni-profile-pictures/default-avatar.jpg') {
                isPersonalPhotoUploaded = "Yes";
              } else {
                isPersonalPhotoUploaded = "No";
              }

              return {
                student_id: obj.student_id,
                eid: obj.eid,
                name_en: obj.name_en,
                name_ar: obj.name_ar,
                entity: this.getEntityName(obj.entity),
                campus: obj.campus_code,
                program_name: this.getSpecialization(obj.entity, obj.study_program, obj.program_name, obj.program_code, obj.cluster_e, obj.specialization),
                gpa: obj.gpa || "",
                nationality: obj.nationality || "",
                alumni_phone: obj.alumni_phone || "",
                primary_phone: obj.primary_phone || "",
                secondary_phone: obj.secondary_phone || "",
                primary_email: obj.primary_email || "",
                secondary_email: obj.secondary_email || "",
                is_personal_photo_uploaded: isPersonalPhotoUploaded,
                is_emirates_id_uploaded: isEmiratesIdUploaded,
                registered: regStatus,
              };
            })
          );
          // Move to the next page
          page++;
        } else {
          this.isApiCallRecurisive = false;
          // No more data available, exit the loop
          break;
        }
      }
      this.exportExcel("Graduating_Students");
    },

    async fetchForExporting(pageNo = 1, limitSize = 50) {
      try {
        const { data } = await this.$apollo.query({
          query: gql`
            query generateGraduatingStudentReport(
              $page: Int
              $limit: Int
              $entity: String
              $campus: String
              $reg_status: String
              $local_or_non_local: String
              $is_final_year_student: Boolean
              $search: String
              $gpa: String
              $nationality: String
            ) {
              generateGraduatingStudentReport(
                page: $page
                limit: $limit
                entity: $entity
                campus: $campus
                reg_status: $reg_status
                local_or_non_local: $local_or_non_local
                is_final_year_student: $is_final_year_student
                search: $search
                gpa: $gpa
                nationality: $nationality
              ) {
                error
                error_code
                message
                data {
                  student_id
                  eid
                  name_en
                  name_ar
                  entity
                  campus_code
                  primary_email
                  secondary_email
                  alumni_phone
                  primary_phone
                  secondary_phone
                  reg_status
                  study_program
                  program_name
                  program_code
                  cluster_e
                  specialization
                  gpa
                  nationality
                  emirates_id_file
                  user {
                    profile_picture_url
                  }
                }
              }
            }
          `,
          fetchPolicy: "network-only",
          variables: {
            entity: this.filterByEntity,
            reg_status: this.filterByRegistration,
            campus: this.filterByCampus,
            local_or_non_local: this.filterByLocalOrNonLocal,
            page: pageNo,
            limit: limitSize,
            is_final_year_student: true,
            search: this.searchText,
            gpa: this.filterByGpa,
            nationality: this.filterByNationality,
          },
        });

        const responseData = data.generateGraduatingStudentReport;
        return responseData;
      } catch (error) {
        console.log(error.message);
      }
    },

    exportExcel(reportName) {
      const XLSX = xlsx;

      const header = [
        "STUDENT ID",
        "EID",
        "NAME IN ENGLISH",
        "NAME IN ARABIC",
        "ENTITY",
        "CAMPUS",
        "PROGRAM NAME",
        "GPA",
        "NATIONALITY",
        "ALUMNI PHONE",
        "PRIMARY PHONE",
        "SECONDARY PHONE",
        "PRIMARY EMAIL",
        "SECONDARY EMAIL",
        "Personal Photo Uploaded",
        "Emirates ID Uploaded",
        "REGISTRATION STATUS",
      ];

      const worksheet = XLSX.utils.json_to_sheet(this.generatedReport);

      worksheet["A1"] = { v: header[0], t: "s" };
      worksheet["B1"] = { v: header[1], t: "s" };
      worksheet["C1"] = { v: header[2], t: "s" };
      worksheet["D1"] = { v: header[3], t: "s" };
      worksheet["E1"] = { v: header[4], t: "s" };
      worksheet["F1"] = { v: header[5], t: "s" };
      worksheet["G1"] = { v: header[6], t: "s" };
      worksheet["H1"] = { v: header[7], t: "s" };
      worksheet["I1"] = { v: header[8], t: "s" };
      worksheet["J1"] = { v: header[9], t: "s" };
      worksheet["K1"] = { v: header[10], t: "s" };
      worksheet["L1"] = { v: header[11], t: "s" };
      worksheet["M1"] = { v: header[12], t: "s" };
      worksheet["N1"] = { v: header[13], t: "s" };
      worksheet["O1"] = { v: header[14], t: "s" };
      worksheet["P1"] = { v: header[15], t: "s" };
      worksheet["Q1"] = { v: header[16], t: "s" };

      worksheet["!cols"] = [
        { width: 40 },
        { width: 40 },
        { width: 30 },
        { width: 30 },
        { width: 20 },
        { width: 20 },
        { width: 40 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 60 },
        { width: 20 },
        { width: 20 },
      ];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, `${reportName}.xlsx`);
      this.generatedReport = [];
      this.isExportExcel = false;
      this.isApiCallRecurisive = false;
    },
    async getSpecializations() {
      try {
        const { data } = await this.$apollo.query({
          query: gql`
            query GetSpecializations(
              $student_status: String
              $entity: String
              $academic_year: [String]
            ) {
              getSpecializations(
                student_status: $student_status
                entity: $entity
                academic_year: $academic_year
              )
            }
          `,
          variables: {
            student_status: "IG",
            entity: this.filterByEntity,
            academic_year: [],
          },
        });
        this.specializationsList = data.getSpecializations;
      } catch (error) {
        console.log(error);
      }
    },
    async getNationalities() {
      try {
        const { data } = await this.$apollo.query({
          query: gql`
            query GetNationalities(
              $student_status: String
              $entity: String
              $is_final_year_student: Boolean
            ) {
              getNationalities(
                student_status: $student_status
                entity: $entity
                is_final_year_student: $is_final_year_student
              )
            }
          `,
          variables: {
            student_status: "AS",
            entity: this.filterByEntity,
            is_final_year_student: true,
          },
        });
        this.nationalities = data.getNationalities;
      } catch (error) {
        console.log(error);
      }
    },
    async getCampusList() {
      try {
        const { data } = await this.$apollo.query({
          query: gql`
            query GetCampusList($student_status: String, $entity: String) {
              getCampusList(student_status: $student_status, entity: $entity) {
                entity
                campus_code
              }
            }
          `,
          variables: {
            student_status: "IG",
            entity: this.filterByEntity,
          },
          fetchPolicy: "network-only",
        });
        this.campusList = data.getCampusList;
      } catch (error) {
        console.log(error);
      }
    },
    getLabelBasedOnEntity() {
      switch (this.filterByEntity) {
        case "ATHS":
          return ["ATS"];
        case "ADPOLY":
          return ["ADPOLY"];
        case "FCHS":
          return ["FCHS"];
        case "ADVETI":
          return ["ADVETI"];
        default:
          return ["ATS", "ADPOLY", "FCHS", "ADVETI"];
      }
    },
    async getGraduatingStudentsDashboard() {
      this.isDashboardLoading = true;
      try {
        const { data } = await this.$apollo.query({
          query: gql`
            query GetGraduatingStudentsDashboard(
              $entity: String
              $campus_code: String
              $local_or_non_local: String
              $reg_status: String
              $specialization: String
              $gpa: String
              $nationality: String
            ) {
              getGraduatingStudentsDashboard(
                entity: $entity
                campus_code: $campus_code
                local_or_non_local: $local_or_non_local
                reg_status: $reg_status
                specialization: $specialization
                gpa: $gpa
                nationality: $nationality
              ) {
                data {
                  total_count
                  ats_count
                  fchs_count
                  adpoly_count
                  adveti_count
                  registered
                  pending
                  not_registered
                  campus_wise_list {
                    campus_code
                  }
                  campus_wise_data {
                    registered
                    pending
                    not_registered
                  }
                }
              }
            }
          `,
          variables: {
            entity: this.filterByEntity,
            campus_code: this.filterByCampus,
            local_or_non_local: this.filterByLocalOrNonLocal,
            reg_status: this.filterByRegistration,
            specialization: this.filterBySpecialization,
            gpa: this.filterByGpa,
            nationality: this.filterByNationality,
          },
          fetchPolicy: "network-only",
        });

        const graduatingStudentsDashboardData =
          data.getGraduatingStudentsDashboard.data;

        this.totalCount = graduatingStudentsDashboardData.total_count;
        this.atsCount = graduatingStudentsDashboardData.ats_count;
        this.adpolyCount = graduatingStudentsDashboardData.adpoly_count;
        this.fchsCount = graduatingStudentsDashboardData.fchs_count;
        this.advetiCount = graduatingStudentsDashboardData.adveti_count;

        this.registered = graduatingStudentsDashboardData.registered;
        this.pending = graduatingStudentsDashboardData.pending;
        this.notRegistered = graduatingStudentsDashboardData.not_registered;

        this.campus_wise_list =
          graduatingStudentsDashboardData.campus_wise_list;
        this.campus_wise_data =
          graduatingStudentsDashboardData.campus_wise_data;
      } catch (error) {
        console.log(error);
      }
      this.isDashboardLoading = false;
    },
    getEntityName(entity) {
      if (entity == "ATHS") {
        return "ATS";
      } else {
        return entity;
      }
    },
    getSpecialization(
      entity,
      studyProgram,
      programName,
      programCode,
      clusterE,
      specializationValue
    ) {
      let specialization = "";
      if (entity == "ATHS") {
        if (specializationValue) {
          specialization = specializationValue;
        } else if (clusterE) {
          specialization = clusterE;
        } else if (programName) {
          specialization = programName;
        } else if (studyProgram) {
          specialization = studyProgram;
        } else {
          specialization = programCode;
        }
      } else {
        if (specializationValue) {
          specialization = specializationValue;
        } else if (programName) {
          specialization = programName;
        } else if (studyProgram) {
          specialization = studyProgram;
        } else {
          specialization = programCode;
        }
      }
      return specialization;
    },
    getCreditEarned(creditsearned, reqCredit) {
      if (creditsearned && reqCredit) {
        return `${creditsearned} / ${reqCredit}`;
      } else {
        return "";
      }
    },
    isRegistered(status) {
      if (status) {
        return "Yes";
      } else {
        return "No";
      }
    },
    isShowChart(entity) {
      if (this.filterByEntity == "") {
        return true;
        // if (this.role == 'superadmin' || this.userEntities === null) {
        //     return true;
        // } else {
        //     const entitiesArray = this.userEntities.split(",");
        //     if (entitiesArray.includes(entity)) {
        //         return true;
        //     } else {
        //         return false;
        //     }
        // }
      } else {
        return this.filterByEntity == entity;
      }
    },
    setPage(page) {
      this.page = page;
    },

    openPreviewImgModalNew(student) {
      this.previewImageModal = true;
      if (
        student.profile_picture_url ==
        "/storage/alumni-profile-pictures/default-avatar.jpg" ||
        student.profile_picture_url == null
      ) {
        this.previewImg = `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${student.student_id}/${student.entity}`;
      } else {
        this.previewImg =
          process.env.VUE_APP_PUBLIC_URL + student.profile_picture_url;
      }
    },
    studentProfileNew(student) {
      if (
        student.profile_picture_url ==
        "/storage/alumni-profile-pictures/default-avatar.jpg" ||
        student.profile_picture_url == null
      ) {
        return `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${student.student_id}/${student.entity}`;
      } else {
        return process.env.VUE_APP_PUBLIC_URL + student.profile_picture_url;
      }
    },

    getProfilePicture(studentId, entity) {
      return `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
    },
    onSearch(searchText) {
      this.searchText = searchText;
    },
    openPreviewImgModal(studentId, entity) {
      this.previewImageModal = true;
      this.previewImg = `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
    },
    closePreviewImageModal() {
      this.previewImageModal = false;
      this.previewImg = "";
    },
    hasPermission(crudName) {
      if (this.role == "superadmin") {
        return true;
      } else {
        const permissions = this.$store.getters.permissions;
        const permissionsArray = permissions.split(",");
        if (permissionsArray.includes(crudName)) {
          return true;
        } else {
          return false;
        }
      }
    },
    closeFullModal() {
      this.showStudentProfileFullModal = false;
      this.studentId = null;
    },
    viewStudentProfile(studentId) {
      this.studentId = studentId;
      this.showStudentProfileFullModal = true;
    },
    async generatePdf(studentId) {
      document.body.classList.add("loading");
      this.isGenerateReport = true;

      const GENERATE_PDF_MUTATION = gql`
        mutation GeneratePdfStudentProfile(
          $student_id: String
          $name: String!
        ) {
          generatePdf(student_id: $student_id, name: $name) {
            error
            error_code
            message
            url
          }
        }
      `;

      let error_msg = "";
      let redirect_url = "";

      try {
        await this.$apollo
          .mutate({
            mutation: GENERATE_PDF_MUTATION,
            variables: {
              student_id: studentId,
              name: "student-information",
            },
          })
          .then((data) => {
            if (data.data.generatePdf.error) {
              error_msg = data.data.generatePdf.message;
            } else {
              redirect_url = data.data.generatePdf.url;
            }
          })
          .catch((error) => {
            error_msg = error;
          });
      } catch (error) {
        error_msg = error.message || "Failed to authenticate, try later.";
      }

      if (error_msg) {
        this.$swal
          .fire({
            icon: "error",
            title: "Oops...",
            text: error_msg,
          })
          .then((result) => {
            console.log(result);
          });
      } else {
        const url = process.env.VUE_APP_PUBLIC_URL + redirect_url;
        window.open(url, "_blank");
      }

      this.isGenerateReport = false;
      document.body.classList.add("loading");
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

body.loading {
  filter: blur(5px);
}

#loading-overlay {
  background-color: rgba(0, 0, 0, 0.25);
}

@responsive {
  .wd-380 {
    width: 380px;
  }

  .ht-242-7 {
    height: 242.7px;
  }

  .wd-216 {
    width: 216px;
  }

  .ht-216 {
    height: 216px;
  }

  .ht-350 {
    height: 350px;
  }

  .ht-430 {
    height: 430px;
  }

  .ht-60-vh {
    height: 60vh;
  }

  .ht-700 {
    height: 700px;
  }
}

.text-map-color {
  color: #09306b;
}

.vue-world-map {
  height: 60vh;
}

@media only screen and (max-width: 1023px) {
  .vue-world-map {
    height: 100%;
  }
}
</style>
